import { Component } from '@theme/component';

/** Keeps the shared navigation fixed and collapses only its mobile search row. */
class SelfStickyHeader extends Component {
  /** @type {{ header?: HTMLElement, searchBar?: HTMLFormElement }} */
  refs;
  #controller;
  #observer;
  #frame = 0;
  #expandedHeight = 0;
  #mobile = window.matchMedia('(max-width: 1199px)');

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    window.addEventListener('scroll', this.#schedule, { ...options, passive: true });
    window.addEventListener('resize', this.#reset, options);
    this.addEventListener('focusout', this.#schedule, options);
    this.#observer = new ResizeObserver(this.#schedule);
    if (this.refs.header) this.#observer.observe(this.refs.header);
    this.#reset();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#observer?.disconnect();
    if (this.refs.header) this.#observer?.observe(this.refs.header);
    this.#reset();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #reset = () => {
    const search = this.refs.searchBar;
    if (search) search.hidden = false;
    this.#expandedHeight = this.refs.header?.getBoundingClientRect().height || 0;
    this.#schedule();
  };

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      const { header, searchBar } = this.refs;
      if (!header) return;
      const sticky = header.dataset.sticky === 'true';
      if (searchBar) {
        searchBar.hidden = sticky && this.#mobile.matches && window.scrollY > 1 &&
          !searchBar.contains(document.activeElement);
      }
      const height = header.getBoundingClientRect().height;
      if (!searchBar?.hidden) this.#expandedHeight = height;
      this.closest('.shopify-section')?.style.setProperty('--self-header-placeholder-height', `${this.#expandedHeight}px`);
      document.body.style.setProperty('--header-height', `${height}px`);
    });
  };
}

if (!customElements.get('self-sticky-header')) {
  customElements.define('self-sticky-header', SelfStickyHeader);
}
